module.exports = __webpack_public_path__ + "img/c_date.b1765dae.png";